import { render, staticRenderFns } from "./Disabilities.vue?vue&type=template&id=6ec9be12&scoped=true&"
import script from "./Disabilities.vue?vue&type=script&lang=js&"
export * from "./Disabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec9be12",
  null
  
)

export default component.exports